module.exports = __webpack_public_path__ + "static/img/audio_default.0b7e24fd.png";